import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private _HttpClient: HttpClient) {}

  paymentTypePending(): Observable<any> {
    return this._HttpClient.get(
      environment.baseUrl + 'admin/get-booking-by-payment-type',
      { params: { payment_type: 'admin_visa_pending' } }
    );
  }

  paymentTypePaid(): Observable<any> {
    return this._HttpClient.get(
      environment.baseUrl + 'admin/get-booking-by-payment-type',
      { params: { payment_type: 'admin_visa_paid' } }
    );
  }

  initiatePayment(formData: any): Observable<any> {
    return this._HttpClient.post(
      environment.baseUrl + 'admin/initiate-payment',
      formData
    );
  }

  executePayment(formData: any): Observable<any> {
    return this._HttpClient.post(
      environment.baseUrl + 'admin/excute-payment',
      formData
    );
  }

  paymentALl(formData: any): Observable<any> {
    return this._HttpClient.post(
      environment.baseUrl + 'admin/bulk-cash-payment',
      formData
    );
  }
}
